<template>
  <div>
    <!-- 顶部按钮 -->
    <a-row :gutter="24">
      <a-col :span="12" style="margin: 10px 0px">
        <a-button type="primary" @click="openAddVisible" :disabled="!isEditable"
          >新增</a-button
        >
      </a-col>
    </a-row>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :data-source="form.supplyCheckList"
      :pagination="false"
      rowKey="id"
    >
      <template slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </template>

      <template slot="attachments" slot-scope="text, record">
        <div class="attachment-cell">
          <template v-if="record.attachments && record.attachments.length">
            <div
              v-for="(item, idx) in record.attachments"
              :key="item.uid || idx"
              class="attachment-item"
            >
              <a @click="downloadFile(item)" style="color: #1890ff">
                {{ item.name }}
              </a>
            </div>
          </template>
          <span v-else>--</span>
        </div>
      </template>

      <template slot="remark" slot-scope="text, record">
        <template v-if="record.remark">
          <div>{{ record.remark }}</div>
        </template>
        <span v-else>无</span>
      </template>

      <template slot="action" slot-scope="text, record, index">
        <template v-if="isEditable">
          <a @click="deleteRow(index)" style="color: #1890ff">删除</a>
          <a-divider type="vertical" />
          <a @click="editRow(record, index)" style="color: #1890ff">修改</a>
        </template>
        <template v-else>
          <a @click="viewRow(record)" style="color: #1890ff">查看</a>
        </template>
      </template>
    </a-table>

    <!-- 弹窗 -->
    <a-modal
      :visible="addVisible"
      :footer="null"
      width="700px"
      :maskClosable="false"
      destroyOnClose
      @cancel="closeAddModule"
    >
      <div class="modal-title">{{ modalTitle }}</div>

      <div class="supply-area">
        <a-form-model
          ref="formRef"
          :model="materialFormData"
          :rules="materialRules"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 19 }"
          class="material-form"
        >
          <!-- 文件名称 -->
          <a-form-model-item label="文件名称" prop="fileName" required>
            <a-input
              v-model="materialFormData.fileName"
              :maxLength="100"
              placeholder="请输入文件名称"
              :disabled="isView"
            />
          </a-form-model-item>

          <!-- 电子件 -->
          <a-form-model-item label="电子件" prop="attachments" required>
            <a-upload
              action="https://api.jssyjt.net/external-service-center/uploadFile/attachment"
              :headers="uploadHeaders"
              :file-list="materialFormData.attachments"
              :disabled="isView"
              :multiple="true"
              :show-upload-list="{ showRemoveIcon: !isView }"
              :data="{ uploadType: 501 }"
              @change="handleAttachmentChange"
              @download="downloadFile"
              @preview="downloadFile"
            >
              <a-button
                v-if="!isView"
                style="display: flex; align-items: center"
              >
                <a-icon type="upload" />
                <span style="margin-top: 2px">添加文件</span>
              </a-button>
            </a-upload>
          </a-form-model-item>

          <!-- 备注 -->
          <a-form-model-item label="备注" prop="remark">
            <a-textarea
              v-model="materialFormData.remark"
              placeholder="请输入备注"
              :disabled="isView"
            />
          </a-form-model-item>

          <!-- 底部按钮 -->
          <a-form-model-item :wrapper-col="{ span: 24 }" class="footer-btns">
            <a-button class="cancel-btn" @click="closeAddModule">
              {{ isView ? "关闭" : "取消" }}
            </a-button>
            <a-button v-if="!isView" type="primary" @click="submitForm">
              确定
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";

const columns = [
  {
    title: "序号",
    width: 80,
    align: "center",
    scopedSlots: { customRender: "index" },
  },
  {
    title: "文件名",
    width: 200,
    dataIndex: "fileName",
    align: "center",
  },
  {
    title: "电子件",
    width: 400,
    dataIndex: "attachments",
    align: "center",
    scopedSlots: { customRender: "attachments" },
  },
  {
    title: "备注",
    width: 200,
    dataIndex: "remark",
    align: "center",
    scopedSlots: { customRender: "remark" },
  },
  {
    title: "操作",
    width: 160,
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      columns,
      addVisible: false,
      editIndex: null,
      modalType: "add", // add / edit / view
      materialFormData: {
        fileName: "",
        attachments: [],
        remark: "",
      },
      materialRules: {
        fileName: [
          {
            required: true,
            message: "请输入文件名称",
            trigger: "blur",
          },
        ],
        attachments: [
          {
            validator: (rule, value, callback) => {
              if (!Array.isArray(value) || value.length === 0) {
                callback(new Error("请上传电子件"));
                return;
              }

              //如果有 uploading 状态，直接跳过校验
              const uploading = value.some(
                (item) => item.status === "uploading"
              );
              if (uploading) {
                callback();
                return;
              }

              const doneList = value.filter((item) => item.status === "done");
              if (doneList.length === 0) {
                callback(new Error("请至少上传一个成功附件"));
                return;
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token || "",
      };
    },
    isView() {
      return this.modalType === "view";
    },
    modalTitle() {
      if (this.modalType === "edit") return "新增材料补充";
      if (this.modalType === "view") return "查看材料补充";
      return "新增材料补充";
    },
  },
  created() {
    if (!Array.isArray(this.form.supplyCheckList)) {
      this.$set(this.form, "supplyCheckList", []);
    }
  },
  methods: {
    getDefaultFormData() {
      return {
        fileName: "",
        attachments: [],
        remark: "",
      };
    },

    resetFormData() {
      this.materialFormData = this.getDefaultFormData();
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    openAddVisible() {
      if (!this.isEditable) return;
      this.modalType = "add";
      this.editIndex = null;
      this.resetFormData();
      this.addVisible = true;
    },

    closeAddModule() {
      this.addVisible = false;
      this.editIndex = null;
      this.modalType = "add";
      this.resetFormData();
    },

    handleAttachmentChange({ fileList }) {
      const newList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          }
          return {
            uid: item.uid,
            name: item.name,
            status: "error",
            url: undefined,
          };
        }
        return item;
      });

      this.materialFormData.attachments = newList;

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField("attachments");
        }
      });
    },

    downloadFile(file) {
      if (!file || !file.url) return;
      const tmpcnt = file.name.lastIndexOf(".");
      const exname = file.name.substring(tmpcnt + 1).toLowerCase();
      const previewTypes = ["pdf", "txt"];
      if (previewTypes.indexOf(exname) < 0) {
        const a = document.createElement("a");
        a.href = file.url;
        a.click();
      } else {
        window.open(file.url);
      }
    },

    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const submitData = {
          id:
            this.editIndex !== null && this.form.supplyCheckList[this.editIndex]
              ? this.form.supplyCheckList[this.editIndex].id
              : uuidv4(),
          fileName: this.materialFormData.fileName,
          attachments: (this.materialFormData.attachments || []).map(
            (item) => ({
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: item.url,
            })
          ),
          remark: this.materialFormData.remark,
        };

        if (this.editIndex !== null) {
          this.$set(this.form.supplyCheckList, this.editIndex, submitData);
          this.$notification.success({
            message: "修改材料补充",
            description: "成功",
          });
        } else {
          this.form.supplyCheckList.push(submitData);
          this.$notification.success({
            message: "新增材料补充",
            description: "成功",
          });
        }

        this.closeAddModule();
      });
    },

    editRow(row, index) {
      if (!this.isEditable) return;
      this.modalType = "edit";
      this.editIndex = index;
      this.materialFormData = {
        fileName: row.fileName || "",
        attachments: row.attachments
          ? row.attachments.map((item) => ({
              uid: item.uid,
              name: item.name,
              status: item.status || "done",
              url: item.url,
            }))
          : [],
        remark: row.remark || "",
      };
      this.addVisible = true;

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    viewRow(row) {
      this.modalType = "view";
      this.editIndex = null;
      this.materialFormData = {
        fileName: row.fileName || "",
        attachments: row.attachments
          ? row.attachments.map((item) => ({
              uid: item.uid,
              name: item.name,
              status: item.status || "done",
              url: item.url,
            }))
          : [],
        remark: row.remark || "",
      };
      this.addVisible = true;

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    deleteRow(index) {
      if (!this.isEditable) return;
      this.$confirm({
        title: "确认删除？",
        content: "删除后不可恢复",
        onOk: () => {
          this.form.supplyCheckList.splice(index, 1);
          this.$notification.success({
            message: "删除材料补充",
            description: "成功",
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.attachment-cell {
  text-align: left;
  padding: 0 8px;
}

.attachment-item /deep/ .ant-upload-list-item-name {
  position: relative;
  top: 3px;
  display: inline-block;
  max-width: 450px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.material-form /deep/ .ant-form-item-label > label {
  color: #333;
}

.material-form /deep/ .ant-input,
.material-form /deep/ .ant-input-textarea textarea {
  border-radius: 4px;
}

.material-form /deep/ .ant-upload-list-item-name {
  display: inline-block;
  max-width: 420px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.footer-btns {
  text-align: center;
  margin-top: 32px;
  margin-bottom: 0;
}

.cancel-btn {
  margin-right: 16px;
}

/* 关键部分：修复输入框宽度异常 */
.supply-area /deep/ input.ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>